import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VisitService } from '../rest_services/visit.service';
import { SettingsService } from '../rest_services/settings.service';
import { load } from '@amcharts/amcharts4/.internal/core/utils/Net';

@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.css']
})
export class ConfigComponent implements OnInit {

  reviveWeekForm: FormGroup;
  visitDeadline: FormGroup;

  authorizeRelanceForm: FormGroup;
  // authorized:boolean=false;
  modifyAuthorizationLoading:boolean=false;

  authorizeCloseDailyNotifForm: FormGroup;
  authorizedCloseDaily:boolean=false;
  modifyCloseDailyLoading:boolean=false;

  visibilityConfigForm: FormGroup;
  loading: boolean = false;
  activateSurveyForm: FormGroup;

  reviveCaPerformanceForm: FormGroup;

  constructor(private fb: FormBuilder,private visitService:VisitService,
      private settingsService:SettingsService) {
        this.reviveWeekForm = this.fb.group({
          'day': [''],
          'time':[''],
        });
        this.visitDeadline = this.fb.group({
          'visitMinDeadline': [''],
        });
        this.activateSurveyForm = this.fb.group({
          'survey': [''],
        });
        this.visibilityConfigForm = this.fb.group({
          skypeVisibility: [false],
          zipCodeVisibility: [false]
        });
        this.authorizeRelanceForm = this.fb.group({
          'authorize': ['']
        });
        this.authorizeCloseDailyNotifForm = this.fb.group({
          'authorize': ['']
        });
        this.reviveCaPerformanceForm = this.fb.group({
          'period': [''],
        });
      // this.reviveWeekForm.controls['sector_uuid'].setValue("", {onlySelf: true});
      // this.reviveWeekForm.controls['customer_uuid'].setValue("", {onlySelf: true});
      // this.reviveWeekForm.controls['city_uuid'].setValue("", {onlySelf: true});
  }
  days:any[]=[
    {
      "day_name":"Lundi",
      "day_uuid":"adf77274a0282824941028ebeb0eb14e"
    },
    {
      "day_name":"Mardi",
      "day_uuid":"a7851e337fed250055f61d74b93a3e07"
    },
    {
      "day_name":"Mercredi",
      "day_uuid":"2e5b577986cfac4b693f98dac9ffc7fa"
    },
    {
      "day_name":"Jeudi",
      "day_uuid":"619b47ea9d0f73127f85cd54d939eaa9"
    },
    {
      "day_name":"Vendredi",
      "day_uuid":"e99d665d9e32e08c02cb6f79f69e8016" //1223
    },
    {
      "day_name":"Samedi",
      "day_uuid":"4b0acbb8dce13838c2a9c87bb0325b1c" //1223
    }
  ];
  hours:any[]=['00.00', '00.30', '01.00', '01.30', '02.00', '02.30', '03.00', '03.30', '04.00', '04.30', '05.00', '05.30', '06.00', '06.30', '07.00', '07.30', '08.00', '08.30', '09.00', '09.30', '10.00', '10.30', '11.00', '11.30', '12.00', '12.30', '13.00',
  '13.30', '14.00', '14.30', '15.00', '15.30', '16.00', '16.30', '17.00', '17.30', '18.00', '18.30', '19.00', '19.30',
  '20.00', '20.30', '21.00', '21.30', '22.00', '22.30', '23.00', '23.30'
  ];
  frequences:any[]=[
    {
      "frequence_name":"Hebdomadaire",
      "frequence_uuid":"HEBDO"
    },
    {
      "frequence_name":"Mentuelle",
      "frequence_uuid":"MONTHLY"
    }
  ];
  crenaux_relance:any[]=[
    // {
    //   "relanceday":"day"
    // },{
    //   "relanceday":"day"
    // }
  ]
  role:any=null;
  visitDeadlineValue :any;
  loader:boolean=false;
  success:boolean=false;
  failed:boolean=false;
  message:any="";
  ngOnInit(): void {
    this.getConfig();
    this.autoConfigInitialisation();
    var glob = this;
    
    if(localStorage.getItem("role")!=undefined) {
      this.role =localStorage.getItem("role");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.role =sessionStorage.getItem("role");
    }
    this.roles = JSON.parse(sessionStorage.getItem('userRoles') || '[]');

    $("#activeRelanceSwitch").change(function(){
        if( $(this).is(":checked") ){
        }else{
          glob.newRevive(false);
        }
    });
    this.getReviveSlot("beforeConfig");
  }

  deadlineLoader : boolean = false;
  msgError:any = '';
  msgSucces:any = '';
  saveVisiteDeadline() {
    this.deadlineLoader = true ;
    const visitMinDeadlineValue = this.visitDeadline.get('visitMinDeadline')?.value;
    this.settingsService.setVisitDeadline(visitMinDeadlineValue);
    this.settingsService.deadlineSubject.subscribe(
      ( data: any ) => {
        this.deadlineLoader = false ;
        if(data.code=="45859d1ba9e878f62c51935e3119d7ad"){
          this.msgSucces = ' La configuration du délai minimal entre démarrer et terminer une visite a été changée avec succès.'
          $("#deadline_success").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            });
            $("#deadline_success").hide();
          }, 5000);
        }else {
          this.msgError =' La configuration du délai minimal entre démarrer et terminer une visite a échoué.'
          $("#deadline_error").show();
          $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#deadline_error").hide();
          }, 5000);
        }
      },
    )
  }

  toggleVisibility(event: Event, field: string): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.visibilityConfigForm.get(field + 'Visibility')?.setValue(isChecked);
  }
  saveFieldVisibilty(){
    this.deadlineLoader = true ;
    const reqBody = {
      skypeVisibility : this.visibilityConfigForm.get("skypeVisibility")?.value,
      zipCodeVisibility: this.visibilityConfigForm.get("zipCodeVisibility")?.value
    };
    this.settingsService.setFieldVisibility(reqBody);
    this.settingsService.visibilitySubject.subscribe(
      ( data: any ) => {
        this.deadlineLoader = false ;
        if(data.code=="45859d1ba9e878f62c51935e3119d7ad"){
          this.msgSucces = ' La configuration de la visibilité des champs a été changée avec succès.'
          $("#deadline_success").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            });
            $("#deadline_success").hide();
          }, 5000);
        }else {
          this.msgError =' La configuration de la visibilité des champs a échoué.'
          $("#deadline_error").show();
          $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#deadline_error").hide();
          }, 5000);
        }
      },
    )   
  }
  toggleVisibilityHelper(field: string, value: boolean): void {
    const checkboxField = field + 'Visibility';
    this.visibilityConfigForm.get(checkboxField)?.setValue(value);
  }

  enablePeriodNotifsCa:boolean=false;
  getConfig(){
    this.settingsService.getConfig().subscribe(
      (resp: any) => {
        if(resp.code == "45859d1ba9e878f62c51935e3119d7ad"){
          // Update form values based on the retrieved config
          this.visibilityConfigForm.patchValue({
            skypeVisibility: resp.config.skypeVisibility,
            zipCodeVisibility: resp.config.zipCodeVisibility,
          });
          this.activateSurveyForm.patchValue({
            survey: resp.config.survey,
          });
          this.authorizeCloseDailyNotifForm.patchValue({
            authorize: resp.config.closeDayReminder,
          });
          if(resp.config.closeDayReminder){
            $('#activeNotifCloseDay').prop('checked', true);
          }else {
            $('#activeNotifCloseDay').prop('checked', false);
          }
          // Update other form values or UI elements if needed
          this.visitDeadline.get('visitMinDeadline')?.setValue(resp.config.visitDeadline);
          // Switch notif CA Performance
          if(resp.config.authorizeCAPeriodNotifs){
            this.enablePeriodNotifsCa = true;
            $('#activeNotifCaSwitch').prop('checked', true);
            this.reviveCaPerformanceForm.patchValue({
              period: resp.config.periodNotifs,
            });
          }else {
            this.enablePeriodNotifsCa = false;
            $('#activeNotifCaSwitch').prop('checked', false);
            $(".addFrequence").hide();
          }
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  roles :any[] =[];
  hasRole(role: string): boolean {
    return this.roles.includes(role);
  }
  
  activeRelance(e:any){
    if( $("#activeRelanceSwitch").is(":checked") ){
      $(".addCren").show();
      $(".addCren").addClass("fade-in-cren");
    }else{
      this.newRevive(false);
      $(".addCren").hide();
    }
  }
  addCren(){
    var new_cren = {
      "relanceday":"day"
    }
    this.crenaux_relance.push(new_cren)
    setTimeout(()=>{
      var targetday = document.getElementById("dayToSelect") as HTMLElement;
      targetday.removeAttribute("disabled");
      var targettime = document.getElementById("timeToSelect") as HTMLElement;
      targettime.removeAttribute("disabled");
    }, 1000);
  }

  currentReviveWeek:any={};
  showSwitchReviveWeek:boolean=false;
  showSwitchRevivePlanningWeek:boolean=false;
  getReviveSlot(mode:any){
    
    this.visitService.retrieveReviveSlot();
    this.visitService.retrieveReviveWeekSubject.subscribe(
      ( data: any ) => {
        
        if(data.code=="f51c21502d0368a3ba939c870e6753b6"){
          if(data.slotReviveWeek!=null && data.slotReviveWeek !=undefined){
            this.showSwitchReviveWeek = false;
            this.currentReviveWeek = data.slotReviveWeek.dates[0];
            var new_cren = {
              "relanceday":"day"
            }
            if(mode="beforeConfig"){
              this.crenaux_relance.push(new_cren)
            }else {
              this.crenaux_relance = [];
            }
            
            this.reviveWeekForm.controls['day'].setValue(this.currentReviveWeek?.day);
            this.reviveWeekForm.controls['time'].setValue(this.currentReviveWeek?.time);
            
          }else {
            this.reviveWeekForm.controls['day'].setValue("");
            this.reviveWeekForm.controls['time'].setValue("");
            this.showSwitchReviveWeek = true;
          }
          if(data.revivePlanningWeek != undefined && data.revivePlanningWeek 
              && data.revivePlanningWeek != null){
            this.showSwitchRevivePlanningWeek = false;
          }else {
            this.showSwitchRevivePlanningWeek = true;
          }
        }else {
          this.reviveWeekForm.controls['day'].setValue("");
          this.reviveWeekForm.controls['time'].setValue("");
          this.showSwitchRevivePlanningWeek = true;
          this.showSwitchReviveWeek = true;
        }
      },
    )
  }
  action:any;
  reviveWeekDates:any[]=[];
  modifyloading:boolean=false;
  newRevive(mode:any){
    this.modifyloading = true;
    const reviveWeekFormValue = this.reviveWeekForm.value;
    if(this.reviveWeekForm.valid){
      var newDate = {
        day :reviveWeekFormValue.day,
        time:reviveWeekFormValue.time
      }
      this.reviveWeekDates.push(newDate)
      if(!mode){
        this.reviveWeekDates
      }
      var request = {
        activated : mode,
        dates : this.reviveWeekDates
      }
      this.visitService.reviveWeekRequest = request
      this.visitService.setConfigReviveWeek();
      this.visitService.reviveWeekSubject.subscribe(
        ( data: any ) => {
          if(data.code == "2c4efe2ef109be62f9c9ed72434d0ad1"){
            $("#successSave2").show();
            $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            setTimeout(()=>{
              $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              $("#successSave").hide();
            }, 5000);
            this.getReviveSlot("afterConfig");
            this.modifyloading=false;
            this.reviveWeekDates = [];
            this.crenaux_relance = [];
            this.showSwitchReviveWeek = true;
          }else {
            $("#errors").show();
            $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            setTimeout(()=>{
              $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              $("#errors").hide();
            }, 5000);
            this.reviveWeekDates = [];
            this.modifyloading=false;
          }
        },
      ) 
    }
  }

  showSwitchReviveCaPerform:boolean=false;
  

  planningWeekReviveloading:boolean=false;
  activeRevivePlanningWeek(){
    this.loader = true;
    this.planningWeekReviveloading = true;
    const reviveWeekFormValue = this.reviveWeekForm.value;
    this.visitService.setConfigReviveCalendarWeek();
    this.visitService.reviveCalendarWeekSubject.subscribe(
      ( data: any ) => {
        this.loader = false;
        if(data.code == "b56cf6d56cfb45cc0c7c200f15e98396"){
          $("#mailCalendarWeek").show();
          $('.calendarmail').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.calendarmail').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#mailCalendarWeek").hide();
          }, 9000);
          this.getReviveSlot("afterConfig");
          this.showSwitchRevivePlanningWeek=false;
          this.crenaux_relance = [];
          //this.showSwitchReviveWeek = true;
        }else {
          $("#errors").show();
          $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#errors").hide();
          }, 5000);
          this.showSwitchRevivePlanningWeek=false;
          this.planningWeekReviveloading=false;
        }
      },
    ) 
  }

  switchCopyRevive:boolean=false;
  autoConfigInitialisation(){
    this.visitService.autoConfigInitialisation();
    this.visitService.initAutoReviveSubject.subscribe(
      ( data: any ) => {
        this.switchCopyRevive=true;
        if(data.code=="4a972e7d0242f80cb27be7e7f9cbd869"){
          setTimeout(()=>{
            if(data.copyMailAuthorized){
              $('#activeRelanceMailSwitch').prop('checked', true);
            }else {
              $('#activeRelanceMailSwitch').prop('checked', false);
            }
          }, 1000);
        }
        
      },
    )
  }
  failedActivationCopyRelance:boolean=false;
  activeMailRelanceCC(event:any){
    this.loader = true;
    this.failed=false;
    this.success=false; 
    var value = $('#activeRelanceMailSwitch').is(':checked')
    this.settingsService.activeOrDesactiveReviveMailCopy("copy_relance");
    this.settingsService?.copyRelanceSubject?.subscribe(
      ( data: any ) => {
        this.loader = false;
        if(data.code=="45859d1ba9e878f62c51935e3119d7ad"){
          this.failedActivationCopyRelance = false;
          if(value){
            $('#activeRelanceMailSwitch').prop('checked', true);
             this.message="La mise en copie des relances de planification des visites est activée"
          }else {
            $('#activeRelanceMailSwitch').prop('checked', false);
            this.message="La mise en copie des relances de planification des visites est désactivée"
          }
          this.failed=false;
          this.success=true;
          this.loader = false;
        }else {
          this.failedActivationCopyRelance = true;
          this.loader = false;
          this.failed=true;
          this.success=false;
          this.message="La configuration de la mise en copie est échouée, veillez réessayer ultérieurement !"
        }
        setTimeout(() => {
            this.failed=false;
            this.success=false;  
        }, 7000);
      },
    )
  }
  failedActivationCloseDayNotif:boolean=false;
  activeCloseDayNotif(){
    this.loader = true;
    this.failed=false;
    this.success=false; 
    var value = $('#activeNotifCloseDay').is(':checked')
    this.settingsService.activeOrDesactiveCloseDayNotifs("close_day_notifs");
    this.settingsService?.closeDayNotifSubject?.subscribe(
      ( data: any ) => {
        if(data.code=="45859d1ba9e878f62c51935e3119d7ad"){
          this.loader = false;
          if(value){
            $('#activeNotifCloseDay').prop('checked', true);
            this.message="La réception des notifications de fin de journée est activée"
          }else {
            $('#activeNotifCloseDay').prop('checked', false);
            this.message="La réception des notifications de fin de journée est désactivée"
          }
          this.failed=false;
          this.success=true;
        }else {
          this.loader = false;
          this.failed=true;
          this.success=false;
          this.message="La configuration des notifications de fin de journée est échouée, veillez réessayer ultérieurement !"
        }
        setTimeout(() => {
            this.failed=false;
            this.success=false;  
        }, 7000);
      },
    )
  }

  activeSurveySending(event:any){
    this.loader = true;
    var value = $('#activeSurveySwitch').is(':checked')
    this.settingsService.activeOrDesactiveReviveMailCopy("send_survey");
    this.settingsService?.copyRelanceSubject?.subscribe(
      ( data: any ) => {
        this.loader = false;
        if(data.code=="45859d1ba9e878f62c51935e3119d7ad"){
          if(value){
            $('#activeSurveySwitch').prop('checked', true);
          }else {
            $('#activeSurveySwitch').prop('checked', false);
          }
        }else {
        }
      },
    )
  }

  addFrequence(){
    var new_frequence = {
      "notifFrequence":"Hebdomadaire"
    }
    // this.crenaux_relance.push(new_frequence)
    // setTimeout(()=>{
    //   var targetday = document.getElementById("dayToSelect") as HTMLElement;
    //   targetday.removeAttribute("disabled");
    //   var targettime = document.getElementById("timeToSelect") as HTMLElement;
    //   targettime.removeAttribute("disabled");
    // }, 1000);
  }

  // activeNotifsCaPerformance(e:any){
  //   if( $("#activeNotifCaSwitch").is(":checked") ){
  //     $(".addFrequence").show();
  //     $(".addFrequence").addClass("fade-in-cren");
  //   }else{
  //     $(".addFrequence").hide();
  //   }
  // }

  isNotifEnabled: boolean = false;
  activeNotifsCaPerformance(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    this.isNotifEnabled = checkbox.checked;
    this.failed=false;
    this.success=false; 
    if (!this.isNotifEnabled) {
      this.loader = true;
      // Désactivation : appel du service
      this.settingsService.activeOrDesactiveNotifsCA(false).subscribe({
        next: (response) => {
          if(response.code=="f82ac945a6a6900630d7c2dd4a3f4f9f"){//Success
            this.message ="La notification périodiques est désactivée"
            this.success=true; 
            this.failed=false;
            this.enablePeriodNotifsCa = false;
          }else {
            this.message ="La désactivation des notifications périodiques est échouée !"
            this.success=false; 
            this.failed=true;
          }
          this.loader = false;
          $(".addFrequence").hide();
        },
        error: (error) => {
          console.error('Erreur:', error);
          // Remettre le switch à l'état activé en cas d'erreur
          checkbox.checked = true;
          this.isNotifEnabled = true;
        }
      });
    } else {
      $(".addFrequence").show();
      $(".addFrequence").addClass("fade-in-cren");
    }
  }

  newReviveCaPerformance(): void {
    const selectedPeriod = this.reviveCaPerformanceForm.get('period')?.value;
    this.loader = true;
    this.failed=false;
    this.success=false; 
    if (!selectedPeriod) {
      // Période non sélectionnée
      alert('Veuillez sélectionner une fréquence');
      return;
    }
    this.settingsService.activeOrDesactiveNotifsCA(true, selectedPeriod).subscribe({
      next: (response) => {
        if(response.code=="f82ac945a6a6900630d7c2dd4a3f4f9f"){//Success
          this.message ="La notification périodiques est activée"
          this.success=true; 
          this.failed=false;
          this.enablePeriodNotifsCa = true;
        }else { //Failed
          this.message ="L'activation des notifications périodiques est échouée !"
          this.success=false; 
          this.failed=true;
        }
        this.loader = false;
      },
      error: (error) => {
        console.error('Erreur:', error);
      }
    });
  }
}
